<mat-card>
  <mat-card-content class="header-section">
    <div class="header-image">
      <ngx-skeleton-loader [theme]="{height: '100%', width: '100%', margin: '0', 'border-radius': '8px'}"></ngx-skeleton-loader>
    </div>
    <div class="header-info">
      <ngx-skeleton-loader [theme]="{height: '28px', width: '70%', margin: '0 0 8px 0'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '40%', margin: '0 0 24px 0'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '90%', margin: '6px 0'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '80%', margin: '6px 0'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '85%', margin: '6px 0'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '60%', margin: '6px 0'}"></ngx-skeleton-loader>
    </div>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content class="info-section">
    <ngx-skeleton-loader [theme]="{height: '24px', width: '40%', margin: '0 0 16px 0'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '56px', width: '100%', margin: '8px 0', 'border-radius': '8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '56px', width: '100%', margin: '8px 0', 'border-radius': '8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '56px', width: '100%', margin: '8px 0', 'border-radius': '8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '56px', width: '100%', margin: '8px 0', 'border-radius': '8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '56px', width: '100%', margin: '8px 0', 'border-radius': '8px'}"></ngx-skeleton-loader>
  </mat-card-content>
</mat-card>
